/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Changelogcharts_Byweekdaydesc3Inputs */

const id_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan terakumulasi berdasarkan hari dalam seminggu`)
};

const ms_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan terkumpul mengikut hari dalam minggu`)
};

const da_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akkumulerede ændringer efter ugedag`)
};

const de_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesammelte Änderungen nach Wochentag`)
};

const en_us2_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accumulated changes by weekday`)
};

const es_es2_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios acumulados por día de la semana`)
};

const es_mx2_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios acumulados por día de la semana`)
};

const fil_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga naipon na pagbabago ayon sa araw ng linggo`)
};

const fr_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifications cumulées par jour de la semaine`)
};

const it_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifiche accumulate per giorno della settimana`)
};

const hu_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Összegyűjtött változások a hét napjai szerint`)
};

const nl_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verzamelde wijzigingen per weekdag`)
};

const no_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akkumulerte endringer etter ukedag`)
};

const pl_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skumulowane zmiany według dnia tygodnia`)
};

const pt_br2_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accumulated changes by weekday`)
};

const pt_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações acumuladas por dia da semana`)
};

const ro_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificări acumulate după ziua săptămânii`)
};

const fi_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kertyneet muutokset viikonpäivittäin`)
};

const sv_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ackumulerade ändringar per veckodag`)
};

const vi_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thay đổi tích lũy theo ngày trong tuần`)
};

const tr_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hafta gününe göre birikmiş değişiklikler`)
};

const cs_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kumulované změny podle dne v týdnu`)
};

const bg_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Натрупани промени по ден от седмицата`)
};

const ru_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Накопленные изменения по дням недели`)
};

const uk_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Накопичені зміни за днями тижня`)
};

const ar_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التغييرات المتراكمة حسب يوم الأسبوع`)
};

const hi_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सप्ताह के दिन के अनुसार संचित परिवर्तन`)
};

const th_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเปลี่ยนแปลงสะสมตามวันในสัปดาห์`)
};

const ja_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`曜日別の累積変更`)
};

const zh_cn2_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accumulated changes by weekday`)
};

const zh_hant1_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accumulated changes by weekday`)
};

const ko_components_changelogcharts_byweekdaydesc3 = /** @type {(inputs: Components_Changelogcharts_Byweekdaydesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accumulated changes by weekday`)
};

/**
* | output |
* | --- |
* | "Accumulated changes by weekday" |
*
* @param {Components_Changelogcharts_Byweekdaydesc3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_changelogcharts_byweekdaydesc3 = /** @type {((inputs?: Components_Changelogcharts_Byweekdaydesc3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Changelogcharts_Byweekdaydesc3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "ms") return ms_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "da") return da_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "de") return de_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "en-US") return en_us2_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "es-ES") return es_es2_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "es-MX") return es_mx2_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "fil") return fil_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "fr") return fr_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "it") return it_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "hu") return hu_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "nl") return nl_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "no") return no_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "pl") return pl_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "pt-BR") return pt_br2_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "pt") return pt_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "ro") return ro_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "fi") return fi_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "sv") return sv_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "vi") return vi_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "tr") return tr_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "cs") return cs_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "bg") return bg_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "ru") return ru_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "uk") return uk_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "ar") return ar_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "hi") return hi_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "th") return th_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "ja") return ja_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_changelogcharts_byweekdaydesc3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_changelogcharts_byweekdaydesc3(inputs)
	return ko_components_changelogcharts_byweekdaydesc3(inputs)
});
export { components_changelogcharts_byweekdaydesc3 as "components.changelogCharts.byWeekdayDesc" }